import type { TokenStorageGateway } from "@shared-kernel/application/ports/token-storage-gateway";
import { HttpGateway } from "@shared-kernel/secondary/http-gateway";
import config from "../../../../config/backend";
import type {
  ProviderRepository,
  ProviderVM,
  UpdateProviderProfileBody,
  ProviderStudioListItem,
  CreateProviderStudioBody,
  UpdateProviderStudioBody,
} from "@shared-kernel/application/ports/provider/provider-repository";

export class BackendProviderRepository extends HttpGateway implements ProviderRepository {
  private providerRoute: string = "v1/provider";

  constructor(tokenStorageGateway: TokenStorageGateway) {
    super(config.url, tokenStorageGateway);
  }

  async profile(): Promise<ProviderVM> {
    const { data: provider } = await this._instance.get(`${this.providerRoute}/profile`);
    return provider;
  }

  async updateProfile(profile: UpdateProviderProfileBody): Promise<void> {
    await this._instance.put(`${this.providerRoute}/profile`, profile);
  }

  async listStudios(): Promise<ProviderStudioListItem[]> {
    const { data } = await this._instance.get<ProviderStudioListItem[]>(`${this.providerRoute}/studios`);
    return data;
  }

  async getStudioById(id: string): Promise<ProviderStudioListItem> {
    const { data } = await this._instance.get<ProviderStudioListItem>(`${this.providerRoute}/studios/${id}`);
    return data;
  }

  async createStudio(body: CreateProviderStudioBody): Promise<string> {
    const { data } = await this._instance.post(`${this.providerRoute}/studios`, body);
    return data;
  }

  async updateStudio(body: UpdateProviderStudioBody): Promise<void> {
    await this._instance.put(`${this.providerRoute}/studios/${body.id}`, body);
  }
}
